import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ImageUploadModal } from "../../components/modals";
import { IconButton } from "../../components/ui";

const VerificationCard = ({
  title,
  description,
  modalProps = null,
  onSave,
}) => {
  const [open, setOpen] = useState(false);

  const onSetFile = (file) => {
    onSave(file.id);
    setOpen(false);
  };

  return (
    <div className="col-12 col-md-6">
      <ImageUploadModal
        open={open}
        onSetFile={onSetFile}
        closeModal={() => setOpen(false)}
        modalProps={modalProps}
      />

      <div className="card profile-verification-card">
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <img
              width="58"
              height="58"
              src="/assets/icons/alert-warn.png"
              className="align-self-center me-4"
            />
            <div className="align-self-center text-left">
              <h5 className="mb-2">{title}</h5>
              <p>{description}</p>
            </div>
          </div>

          {/* Shared primitive, not a bare <button>: public/css/theme.css:1795
              paints every unclassed button as a 49px black uppercase pill,
              which is what this control used to be. */}
          <IconButton
            variant="ghost"
            size="lg"
            label={`Add ${title}`}
            className="profile-verification-card__action"
            onClick={() => setOpen(true)}
          >
            <FontAwesomeIcon icon={faPlus} size="lg" />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default VerificationCard;
